import config from '@config';
import ArtifactViewerIcon from '@icons/artifact-viewer.svg?react';
import { useArtifactsStore } from '@store/artifacts';
import { useShellStore } from '@store/shell';
import { PrimaryButton } from '@ui/buttons';
import Styled from './ArtifactChatCard.styled';

interface Props {
  versionId: string;
  title: string;
}

function ArtifactChatCard({ title, versionId }: Props) {
  const setCurrentArtifact = useArtifactsStore(
    (store) => store.setCurrentArtifact
  );
  const setArtifactSurface = useShellStore((store) => store.setArtifactSurface);
  const setIsSidebarExpanded = useShellStore(
    (store) => store.setIsSidebarExpanded
  );

  const handleViewArtifact = () => {
    if (window.innerWidth < config.breakpoints.xxLarge) {
      setIsSidebarExpanded(false);
    }

    setCurrentArtifact({ title, versionId });
    setArtifactSurface('panel');
  };

  return (
    <Styled.Wrapper>
      <Styled.IconWrapper>
        <ArtifactViewerIcon />
      </Styled.IconWrapper>
      <Styled.Content>
        <Styled.Text>
          <Styled.Label>Audience profile:</Styled.Label>
          <Styled.Title>{title}</Styled.Title>
        </Styled.Text>
        <PrimaryButton
          startIcon={<Styled.EyeIcon aria-hidden="true" />}
          onClick={handleViewArtifact}>
          View artifact
        </PrimaryButton>
      </Styled.Content>
    </Styled.Wrapper>
  );
}

export default ArtifactChatCard;
